<template>
  <div class="row mx-1 mb-2">
    <div class="col col-5">
      <b>Název materiálu:</b>
    </div>
    <div class="col col-2 position-relative">
      <b>Cena dořezu:</b>
      <i class="bi bi-question-circle position-absolute end-0 translate-middle-y me-3"
         v-tooltip="'Volby určují jakým způsobem bude počítána cena dořezu materiálu (zbylé desky).'"
         data-tooltip-position="top"></i>
    </div>
    <div class="col col-2">
      <b>Rozměr - šířka (mm):</b>
    </div>
    <div class="col col-2 position-relative">
      <b>Rozměr - výška (mm):</b>
      <i class="bi bi-question-circle position-absolute end-0 translate-middle-y me-3"
         v-tooltip="'Umožňuje nastavit jiné rozměry desky materiálu než jsou uvedeny v databázi. Tyto rozměry budou použity pro výpočet plochy desky a dořezů. Takto upravený údaj se nikde neukládá a při dalším výpočtu kalkulace bude výchozí hodnota převzata z databáze.'"
         data-tooltip-position="top"></i>
    </div>
    <div class="col col-1 position-relative">
      <b>Počet desek:</b>
    </div>
  </div>
  <div v-if="usedMaterials.length > 0">
    <div class="row mx-1 mb-1 bg-light py-2 mx-2 rounded" v-for="(material, key) in usedMaterials" :key="key">
      <div class="col col-5 d-flex align-items-center">
        <input class="form-control" type="text" id="material-name" name="material-name"
               :value="materialNameParse(material)" disabled/>
      </div>
      <div class="col col-2 d-flex align-items-center">
        <div>
          <div class="form-check">
            <input class="form-check-input" type="radio" :name="'materialRadio'+key" :id="'noCutoff'+key"
                   value="no_cutoff"
                   @change="inputCutoffUpdate($event, material.id)">
            <label class="form-check-label" :for="'noCutoff'+key">
              Nezapočítávat dořez
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" :name="'materialRadio'+key" :id="'baseCutoff'+key"
                   value="base_cutoff"
                   @change="inputCutoffUpdate($event, material.id)">
            <label class="form-check-label" :for="'baseCutoff'+key">
              Započítat v nákupní ceně
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" :name="'materialRadio'+key" :id="'fullCutoff'+key"
                   value="full_cutoff"
                   @change="inputCutoffUpdate($event, material.id)" checked>
            <label class="form-check-label" :for="'fullCutoff'+key">
              Započítat v plné ceně
            </label>
          </div>
        </div>
      </div>
      <div class="col col-2 d-flex align-items-center">
        <input class="form-control" type="number" id="size-x" name="size-x" :value="material.dimension_x"
               @change="inputDimensionsUpdate($event, material.id, 'x')"/>
      </div>
      <div class="col col-2 position-relative d-flex align-items-center">
        <input class="form-control" type="number" id="size-y" name="size-y" :value="material.dimension_y"
               @change="inputDimensionsUpdate($event, material.id, 'y')"/>
      </div>
      <div class="col col-1 d-flex align-items-center">
        <input class="form-control" type="number" id="count" name="count" :value="inputData[material.id]?.count"
               @change="inputCountUpdate($event, material.id)"
               v-tooltip="'Zde lze uživatelsky změnit počet desek použitých k výpočtu dořezu. Výchozí hodnota je odhadovaný počet desek kalkulátorem. Bude-li hodnota nižší, prořez bude nulový v opačném případě se dopočítá.'"
               data-tooltip-position="top"
               data-tooltip-trigger="focus"/>
      </div>
    </div>
  </div>

</template>

<script setup>
import myApi from "@/api/api";
import {ref, watchEffect, onMounted, defineProps, defineEmits} from 'vue'

const props = defineProps(['cid'])
const emit = defineEmits(['material-dimensions'])

const usedMaterials = ref([])
const inputData = ref({})

const materialNameParse = (item) => {
  const materialOrder = item.order_only ? '- na objednávku' : '- skladem'
  return `${item.name}, ${item.surface}, ${item.thickness.name}, ${item.material.name}, ${item.price_list.name} ${materialOrder}`
}

const convertToInputData = async (data) => {
  const result = {}

  for (const item of data) {
    result[item.id] = {
      x: item.dimension_x,
      y: item.dimension_y,
      cutoff: 'full_cutoff',
      order_only: item.order_only,
      count: item.count ? item.count : 0,
    }

    try {
      const deskCount = await myApi.expectedDeskCount(props.cid, item.id, result[item.id])
      result[item.id].count = deskCount?.count ?? 0
    } catch (error) {
      result[item.id].count = result[item.id].count ?? 0
    }
  }

  return result
}

const inputDimensionsUpdate = (event, material_id, key) => {
  inputData.value[material_id][key] = parseInt(event.target.value);
}

const inputCutoffUpdate = (event, material_id) => {
  inputData.value[material_id].cutoff = event.target.value;
}

const inputCountUpdate = (event, material_id) => {
  inputData.value[material_id].count = parseInt(event.target.value);
}

watchEffect(() => {
  emit('material-dimensions', inputData.value)
})

onMounted(async () => {
  const data = await myApi.allUsedMaterials(props.cid);
  inputData.value = await convertToInputData(data)
  usedMaterials.value = data;
})
</script>

<style scoped>
</style>

